import React, { useState, useEffect, useCallback } from 'react';
import { Button, Space, message, Select, Card, DatePicker, Tabs, Alert, Typography } from 'antd';
import { TableOutlined, SettingOutlined } from '@ant-design/icons';
import api from '../../services/api';
import dayjs from 'dayjs';
import ForecastTable from './ForecastTable';
import ForecastSettings from './ForecastSettings';

const { Text } = Typography;

const Forecast = () => {
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [targetMonth, setTargetMonth] = useState(dayjs().add(1, 'month').format('YYYY-MM'));
    const [activeTab, setActiveTab] = useState('table');
    const [loading, setLoading] = useState(false);

    // Template listesi
    const templates = ['WEB AUTOBUDGET', 'WEB MANUELBUDGET', 'TRENDYOL'];

    const handleBulkCalculate = (results) => {
        message.success(`${results.length} marka için forecast hesaplandı`);
    };

    const tabItems = [
        {
            key: 'table',
            label: (
                <span>
                    <TableOutlined />
                    Forecast Tablosu
                </span>
            ),
            children: (
                <ForecastTable
                    selectedTemplate={selectedTemplate}
                    targetMonth={targetMonth}
                    onBulkCalculate={handleBulkCalculate}
                />
            )
        },
        {
            key: 'settings',
            label: (
                <span>
                    <SettingOutlined />
                    Ayarlar Yönetimi
                </span>
            ),
            children: (
                <ForecastSettings />
            )
        }
    ];

    return (
        <div style={{ padding: '24px' }}>
            <Card>
                <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h2>Ciro Forecast Sistemi</h2>
                    <Space>
                        <Select
                            value={selectedTemplate}
                            onChange={setSelectedTemplate}
                            style={{ width: 200 }}
                            placeholder="Template filtresi"
                            allowClear
                        >
                            {templates.map(template => (
                                <Select.Option key={template} value={template}>
                                    {template}
                                </Select.Option>
                            ))}
                        </Select>
                        
                        <DatePicker
                            picker="month"
                            value={dayjs(targetMonth)}
                            onChange={(date) => setTargetMonth(date ? date.format('YYYY-MM') : null)}
                            format="MMMM YYYY"
                            placeholder="Hedef ay"
                            style={{ width: 150 }}
                        />
                        
                        <Button
                            type="primary"
                            icon={<SettingOutlined />}
                            onClick={() => setActiveTab('settings')}
                        >
                            Ayarları Yönet
                        </Button>
                    </Space>
                </div>

                {selectedTemplate && (
                    <Alert
                        message={`${selectedTemplate} template'ine göre filtreleniyor`}
                        type="info"
                        showIcon
                        closable
                        onClose={() => setSelectedTemplate(null)}
                        style={{ marginBottom: 16 }}
                    />
                )}

                <Tabs
                    activeKey={activeTab}
                    onChange={setActiveTab}
                    items={tabItems}
                    size="large"
                />
            </Card>
        </div>
    );
};

export default Forecast;